/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Error_Shop_Variant_Check_FailedInputs */

const vi_error_shop_variant_check_failed = /** @type {(inputs: Error_Shop_Variant_Check_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chưa kiểm được SKU ${i?.sku} (lỗi mạng). Chọn lại để thử lần nữa.`)
};

/**

* @param {Error_Shop_Variant_Check_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_variant_check_failed = /** @type {((inputs: Error_Shop_Variant_Check_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Variant_Check_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_variant_check_failed(inputs)
});